export default [
    {
        path: '/maps',
        component: () => import(/* webpackChunkName: "maps" */ "@/modules/maps/pages/AppMap.vue"),
        meta: {
            title: "MAPS",
            icon: "mdi-map-marker-radius-outline",
            displayInNavigation: true,
            description: 'Links to different maps and external map applications.'
        },
        children: [
            {
                path: "app-map",
                name: "app-map",
                component: () => import(/* webpackChunkName: "maps" */ "@/modules/maps/pages/WepMap.vue"),
                meta: {
                    title: "MAP (new)",
                    icon: "mdi-map-marker-radius-outline",
                    pageTitle: "Map",
                    gtm: "map",
                    displayInNavigation: true,
                    description: 'The application, or "app" map, is a new map embedded within the application, built on the latest mapping SDKs, and offering improved performance, a new UI, and better integration with other parts of the application.  It does not have all the functionality you will find in some of the older external map applications yet.'
                },
            },
            {
                path: "https://apps.gis.msu.edu/facilities-information-tool/maps/assets",
                meta: {
                    title: "ASSETS",
                    icon: "mdi-map-marker-radius-outline",
                    displayInNavigation: true,
                    description: 'This app is heavily focused on building assets maintained by IPF and allows you to look at assets, floor-by-floor, search for assets and execute queries for groups of assets.',
                    isSecure: true
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://apps.gis.msu.edu/facilities-information-tool/maps/campus",
                meta: {
                    title: "CAMPUS",
                    icon: "mdi-map-marker-radius-outline",
                    displayInNavigation: true,
                    description: 'This map contains generally available facility information for anyone and does not require a login or special access.',
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://apps.gis.msu.edu/construction/closures-and-detours/",
                meta: {
                    title: "CLOSURES AND DETOURS",
                    icon: "mdi-map-marker-radius-outline",
                    displayInNavigation: true,
                    description: 'This application allows you to look at current and future construction impacts and get directions around campus.'
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://apps.gis.msu.edu/facilities-information-tool/maps/benchmarks",
                meta: {
                    title: "BENCHMARKS",
                    icon: "mdi-map-marker-radius-outline",
                    displayInNavigation: true,
                    description: 'This application is focused on MSU\'s network of benchmarks and is intended for staff and business partners conducting survey operations and related activities.'
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://apps.gis.msu.edu/facilities-information-tool/maps/infrastructure",
                meta: {
                    title: "INFRASTRUCTURE",
                    icon: "mdi-map-marker-radius-outline",
                    displayInNavigation: true,
                    description: 'This application is focused on infrastructure outside the building such as underground utilities, plants (managed trees and shrubs), stormwater best management practices and more.'
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://gis.msu.edu/portal/apps/indoors/index.html?appid=86ebb70206df4ddcaf6250f540fecb58",
                meta: {
                    title: "IPF INDOORS",
                    icon: "mdi-navigation-variant",
                    displayInNavigation: true,
                    description: 'Heavily focused on navigating, with room level directions, to assets, work orders, spaces, and more. This application is integrated with AppTree to quickly locate your work and is primarily intended for IPF staff and IPF campus partners.'
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "https://gis.msu.edu/portal/apps/indoors?appid=7409d0452fed4aa689de59f0feee4946",
                meta: {
                    title: "MSU INDOORS",
                    icon: "mdi-navigation-variant",
                    displayInNavigation: true,
                    description: 'The MSU Indoors application allows does not require you to log in and has information primarily intended public users and is primarily focused on focused on navigating, with room level directions, to campus features such as personal health spaces, class locations, points of interest, and more.'
                },
                beforeEnter: (to) => {
                    location.href = to.path
                }
            },
            {
                path: "maps-overview",
                name: "maps-overview",
                component: () => import(/* webpackChunkName: "maps" */ "../pages/MapsOverview.vue"),
                meta: {
                    title: "MAPS OVERVIEW",
                    icon: "mdi-information-outline",
                    pageTitle: "Maps Overview",
                    gtm: "maps-overview",
                    displayInNavigation: true,
                    description: 'An overview of the different maps available from this application.'
                },
            },
            {
                path: "map-help",
                name: "map-help",
                component: () => import(/* webpackChunkName: "maps" */ "../pages/MapsHelp.vue"),
                meta: {
                    title: "MAP HELP",
                    icon: "mdi-information",
                    pageTitle: "Map Help",
                    gtm: "map-help",
                    displayInNavigation: false,
                    description: ''
                },
            }
        ]
    }

]

